interface Props {
  hotelImage: string;
}
const HotelImage = ({ hotelImage }: Props) => {
  return (
    <img
      src={hotelImage}
      alt="hotel-image"
      className="max-h-60 object-cover rounded-[10px]"
    />
  );
};

export default HotelImage;
